

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react"; // ✅ added useEffect
import { fetchOurTeam } from "../../services/api";

export default function LeadershipQuote({lang}) {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [slides, setSlides] = useState([]); // ✅ API data in state
  const [loading, setLoading] = useState(true);
const [pageData, setPageData] = useState(null);
const getImageUrl = (img) => {
  if (!img) return null;
  return (
    img.formats?.large?.url ||
    img.formats?.medium?.url ||
    // img.formats?.small?.url ||
    // img.formats?.thumbnail?.url ||
    img.url ||
    null
  );
};
useEffect(() => {
  setPageData(null);
  setLoading(true);

  const loadData = async () => {
    try {
      const enData = await fetchOurTeam("en");
      const localData = lang !== "en" ? await fetchOurTeam(lang) : enData;
      const source = localData || enData;

      if (source) {
        // Use localized text but fall back to English for image
        setPageData({
          ...source,
          Leader_Quote_image: source.Leader_Quote_image || enData?.Leader_Quote_image,
        });
      }
    } catch (err) {
      console.error("Error loading leadership quote:", err);
    } finally {
      setLoading(false);
    }
  };

  loadData();
}, [lang]); // ✅ lang in dependency array

  if (loading) return <div>Loading...</div>;

  return (

    <div className="padding-x-40 padding-y-80 custom-lg-flex">
      {/* LEFT CONTENT */}
      <div className="w-[100%] lg:w-[50%] ">
        <div>
       

          <h3 className="size-h3 pr-5 pt-2.5 text-dark-blue-color " style={{marginBottom:"0"}}>
         {pageData.Leadership_Quote_Description}
          </h3>

        </div>

        {/* ✅ Use API link text and URL, fallback to "/" */}
        <div className="mt-2.5 md:mt-5">
        <p  className="size-h5 pt-1  text-dark-blue-color" style={{marginBottom:0}}>
        
  
          {pageData.Leader_Name}
             </p>
        <span className="text-accent-blue font-medium">  {pageData.Leader_Designation}</span>
        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div className="w-[100%] lg:w-[50%] ">
      <div className="overflow-hidden rounded-[10px] pt-[40px] lg:pt-0">
{getImageUrl(pageData.Leader_Quote_image) && (
  <img
    src={`${process.env.REACT_APP_Base_URL}${getImageUrl(pageData.Leader_Quote_image)}`}
    className="w-full rounded-[5px] hover:scale-110 transition-transform duration-300"
    alt="img"
  />
)}
        {/* DOT NAVIGATION */}
       
      </div>
     
        </div>
   </div>
  );
}